import { URL } from "@/utils";
// Check fullform for VCJ on PE HUB
const { basePEIURL, brand } = URL;
const brandsThatNeedsFullForm = [""];
const brandsThatNeedsNoLinkInFunds = [""];
const allBrandsTitle = [
  {
    abbreviation: "buyout",
    fullForm: "Buyouts",
  },
  {
    abbreviation: "pei",
    fullForm: "Private Equity International",
  },
  {
    abbreviation: "agri",
    fullForm: "Agri Investor",
  },
  {
    abbreviation: "ii",
    fullForm: "Infrastructure Investor",
  },
  {
    abbreviation: "pdi",
    fullForm: "Private Debt Investor",
  },
  {
    abbreviation: "pehub",
    fullForm: "PE Hub",
  },
  {
    abbreviation: "pere",
    fullForm: "Private Equity Real Estate",
  },
  {
    abbreviation: "si",
    fullForm: "Secondaries Investor",
  },
  {
    abbreviation: "npm",
    fullForm: "New Private Markets",
  },
];

const filterForAbbreviation = (element: {
  name: string;
  url: string;
  fullForm?: string;
  abbreviation: string;
}) => {
  if (
    element.abbreviation !== brand &&
    element.hasOwnProperty("fullForm") &&
    brandsThatNeedsFullForm.includes(brand)
  ) {
    return {
      ...element,
      name: element?.fullForm,
    };
  } else if (element.abbreviation !== brand) {
    return element;
  } else {
    return;
  }
};

const mainNavigationElementsBasedOnBrands: {
  [key: string]: Array<{ title: string; url: string }>;
} = {
  ii: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/news-analysis/`,
    },
    {
      title: "Rankings & Reports",
      url: `${basePEIURL}/infrastructure-investing-rankings/`,
    },
    {
      title: "Bookstore",
      url: `https://www.privateequityinternational.com/product-category/bookstore/`,
    },
    {
      title: "Network & Events",
      url: "https://www.peievents.com/en/",
    },
  ],
  si: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/news-analysis/`,
    },
    {
      title: "Commentary",
      url: `${basePEIURL}/commentary/`,
    },
    {
      title: "Research & Rankings",
      url: `${basePEIURL}/research-and-data/`,
    },
    { title: "Downloads", url: `${basePEIURL}/downloads` },
  ],
  pei: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "Latest News & Analysis",
      url: `${basePEIURL}/news-analysis/`,
    },
    {
      title: "Rankings & Reports",
      url: `${basePEIURL}/private-equity-rankings/`,
    },
    {
      title: "Events",
      url: "https://www.peievents.com/en/",
    },
    {
      title: "Bookstore",
      url: `https://www.privateequityinternational.com/product-category/bookstore/`,
    },
  ],
  pere: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/news-analysis/`,
    },
    {
      title: "Rankings & Reports",
      url: `${basePEIURL}/private-real-estate-rankings/`,
    },
    {
      title: "Bookstore",
      url: `https://www.privateequityinternational.com/product-category/bookstore/`,
    },
    {
      title: "Network & Events",
      url: `${basePEIURL}/network-hub/`,
    },
  ],
  pehub: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/#`,
    },
    {
      title: "Research",
      url: `${basePEIURL}/#`,
    },
    {
      title: "Bookstore",
      url: `https://www.privateequityinternational.com/product-category/bookstore/`,
    },
    {
      title: "Events",
      url: "https://www.peievents.com/en/",
    },
  ],
  agri: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/news-analysis/`,
    },
    {
      title: "Commentary",
      url: `${basePEIURL}/category/commentary/`,
    },
    {
      title: "Data & Reports",
      url: `${basePEIURL}/category/research-and-data`,
    },
    {
      title: "Events",
      url: `https://www.peievents.com/en`,
    },
  ],
  npm: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/news-and-analysis/`,
    },
    {
      title: "Lists & Rankings",
      url: `${basePEIURL}/impact-30-new-faces-in-the-upper-echelons-of-impact/`,
    },
    {
      title: "Bookstore",
      url: `https://www.privateequityinternational.com/product-category/bookstore/`,
    },
    {
      title: "Events",
      url: "https://www.peievents.com/en/",
    },
  ],
  pdi: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "News & Analysis",
      url: `${basePEIURL}/news-analysis/`,
    },
    {
      title: "Rankings & Reports",
      url: `${basePEIURL}/private-debt-rankings/`,
    },
    {
      title: "Video",
      url: `${basePEIURL}/pdi-video/`,
    },
    {
      title: "Events",
      url: "https://www.peievents.com/en/",
    },
  ],
  buyout: [
    {
      title: "Database",
      url: `${basePEIURL}/database`,
    },
    {
      title: "Firms & Funds",
      url: `${basePEIURL}/news-and-analysis/firms-funds`,
    },
    {
      title: "LPs",
      url: `${basePEIURL}/news-and-analysis/lps`,
    },
    {
      title: "Research",
      url: `${basePEIURL}/research-rankings`,
    },
    {
      title: "Events",
      url: "https://www.peievents.com/en/",
    },
  ],
};

const allBrandsTopFooterData: {
  name: string;
  url: string;
  fullForm?: string;
  abbreviation: string;
}[] = [
  {
    abbreviation: "agri",
    name: "Agri Investor",
    url: "https://www.agriinvestor.com/",
  },
  {
    abbreviation: "b",
    name: "Buyouts",
    url: "https://www.buyoutsinsider.com/",
  },
  {
    abbreviation: "ii",
    name: "Infrastructure Investor",
    url: "https://www.infrastructureinvestor.com/",
  },
  {
    abbreviation: "npm",
    name: "New Private Markets",
    url: "https://www.newprivatemarkets.com/",
  },
  {
    abbreviation: "pehub",
    name: "PE Hub",
    url: "https://www.pehub.com/",
  },
  {
    abbreviation: "pei",
    name: "PEI",
    fullForm: "Private Equity International",
    url: "https://www.privateequityinternational.com/",
  },
  {
    abbreviation: "pere",
    name: "PERE",
    url: "https://www.pei-privaterealestate.com/",
  },
  {
    abbreviation: "pdi",
    name: "Private Debt Investor",
    url: "https://www.pei-privatecredit.com/",
  },
  {
    abbreviation: "pfo",
    name: "Private Funds CFO",
    url: "https://www.privatefundscfo.com/",
  },
  {
    abbreviation: "rcw",
    name: "RCW",
    url: "https://www.regcompliancewatch.com/",
  },
  {
    abbreviation: "pcredit",
    fullForm: "PERE Credit",
    url: "https://www.perecredit.com/",
    name: "PERE Credit",
  },
  {
    abbreviation: "ri",
    name: "Responsible Investor",
    url: "https://www.responsible-investor.com/",
  },
  {
    abbreviation: "si",
    name: "Secondaries Investor",
    url: "https://www.pei-secondariesinvestor.com/",
  },
  {
    abbreviation: "vcj",
    fullForm: "Venture Capital Journal",
    url: "https://www.venturecapitaljournal.com/",
    name: "VCJ",
  },
];

const allBrandsBottomFooterData = [
  { name: "Home", link: `${basePEIURL}/` },
  { name: "About us", link: `${basePEIURL}/about-us/` },
  { name: "Contact us", link: `${basePEIURL}/contact-us/` },
  { name: "Sign In FAQ", link: `${basePEIURL}/passwordless-access/` },
  { name: "Privacy Notice", link: `${basePEIURL}/privacy-notice/` },
  { name: "Cookie Notice", link: `${basePEIURL}/cookie-policy/` },
  { name: "Terms & Conditions", link: `${basePEIURL}/terms-conditions/` },
];

let currentBrandsTopFooterData = allBrandsTopFooterData.map(filterForAbbreviation);
if (brand === "buyout") {
  currentBrandsTopFooterData = currentBrandsTopFooterData.filter(
    (element) => element != undefined && element.name?.toLowerCase() !== "buyouts"
  );
} else {
  currentBrandsTopFooterData = currentBrandsTopFooterData.filter((element) => element != undefined);
}

if (brand === "pehub") {
  const temp = currentBrandsTopFooterData[5];
  currentBrandsTopFooterData[5] = currentBrandsTopFooterData[6];
  currentBrandsTopFooterData[6] = temp;
}

const brandsFooterData: {
  [key: string]: {
    topNavigation: any;
    bottomNavigation: Array<{ name: string; link: string }>;
    socialLinks: { linkedIn: string; twitter: string };
  };
} = {
  pei: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/private-equity-international-pei",
      twitter: "https://twitter.com/PEI_news",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  pere: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/pei-pere/",
      twitter: "http://twitter.com/PEREonline",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  ii: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/infrastructureinvestor/",
      twitter: "https://twitter.com/IInews",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  pehub: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/42924407/",
      twitter: "https://twitter.com/PEHUB",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  si: {
    socialLinks: {
      linkedIn: "https://linkedin.com/company/secondaries-investor",
      twitter: "https://twitter.com/secondariespei",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  agri: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/company/agri-investor/",
      twitter: "https://twitter.com/Agri_Investor",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  npm: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/new-private-markets",
      twitter: "https://twitter.com/newprivatemkts",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  pdi: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/5207493/",
      twitter: "http://twitter.com/news_pdi",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
  buyout: {
    socialLinks: {
      linkedIn: "https://www.linkedin.com/showcase/65021448/",
      twitter: "https://twitter.com/Buyouts",
    },
    topNavigation: currentBrandsTopFooterData,
    bottomNavigation: allBrandsBottomFooterData,
  },
};

export const mainNavigationElements = mainNavigationElementsBasedOnBrands[brand];

export const brandFooterData = brandsFooterData[brand].topNavigation;

export const footerBottomNavigation = brandsFooterData[brand].bottomNavigation;

export const socialLinks = brandsFooterData[brand].socialLinks;

export const getBrandTitle = (brandName: string): string => {
  const brand = allBrandsTitle.find((element) => element.abbreviation === brandName);

  if (!brand) {
    return allBrandsTitle[0].fullForm;
  }

  return brand?.fullForm;
};

export const brandsMetaDescription = (brand: string, Institution: string) => {
  switch (brand) {
    case "pere":
      const PereTAndD = titleAndDescription("PERE's", "PERE", Institution);
      return {
        description: PereTAndD.description,
        title: PereTAndD.title,
      };
    case "buyout":
      const BuyoutTAndD = titleAndDescription("Buyouts'", "Buyouts", Institution);
      return {
        description: BuyoutTAndD.description,
        title: BuyoutTAndD.title,
      };
    default:
      const getTitle = getBrandTitle(brand);
      const { description, title } = titleAndDescription(
        `${getTitle}\'s`,
        getBrandTitle(brand),
        Institution
      );
      return {
        description: description,
        title: title,
      };
  }
};
const titleAndDescription = (brandDesc: string, brandTitle: string, Institution: string) => {
  return {
    description: `Use ${brandDesc} platform to access the latest news, analysis, insights and fund data for ${Institution}, as well as key contact information.`,
    title: `${Institution} | Institution Profile | ${brandTitle}`,
  };
};

export const isBrandToSkip = brandsThatNeedsNoLinkInFunds.includes(brand.toLocaleLowerCase());

const anonymousAssetClasses = new Map([
  ["pei", "Private Equity."],
  ["pere", "Private Real Estate."],
  ["ii", "Private Capital Infrastructure investment."],
  ["si", "secondaries markets across alternative asset classes, including Private Equity."],
  ["agri", "private investment in food and agriculture, globally."],
  ["pdi", "the institutions, the funds and the transactions shaping the Private Debt markets."],
  ["pehub", "Private Equity deal-making in North America."],
  [
    "npm",
    "sustainable investment, ESG and impact investing in Private Equity, Real Estate, Infrastructure and Debt.",
  ],
  ["buyout", "the US Private Equity industry, tracking capital flows and fund strategies."],
]);

export const assetClassBasedOnBrandForAnonymous = (brand: string) => {
  return anonymousAssetClasses.get(brand);
};
